import { mapState } from 'vuex';
import { MODELO } from '../enums/Documento';

export default {
  data() {
    return {
      ambientes: [],
    };
  },
  computed: {
    ...mapState('pdv', ['satTransmitter']),
  },
  methods: {
    async getAmbientes() {
      const { data } = await this.$http.get('fiscal.get-ambiente');
      this.ambientes = data;
    },
    async getCurrentEnvironment(gerencialMod = null) {
      let modelo = MODELO.NFCE;

      if (!Array.isArray(this.satTransmitter)) {
        modelo = MODELO.SAT;
      }
      if (gerencialMod !== null) {
        modelo = gerencialMod;
      }

      try {
        const { data } = await this.$http.post('fiscal.get-current-environment', {
          documento: modelo,
        });
        this.currentEnvironment = data;        
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }
    },
  },
};
